import { SvgIcon } from '@material-ui/core';

function CheckboxIndeterminateIcon() {
  return (
    <SvgIcon>
      <path d="M16.445 12.889H7.556v-1.777h8.889zM4 6v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z" />
    </SvgIcon>
  );
}

export default CheckboxIndeterminateIcon;
